var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"guide"},[_c('div',{staticClass:"guide-title",on:{"click":_vm.strategyGuideClick}},[_c('svg-icon',{staticClass:"guide-title-icon",attrs:{"name":"guide","size":"14"}}),_c('div',[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }